"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const hooks_1 = require("../../lib/hooks");
const StyledTextInput = (0, app_1.styled)(ui_1.TextInput) `
  background: white;
  > div > input {
    outline: none;
  }
`;
const StyledSubmit = (0, app_1.styled)(ui_1.Submit) `
  height: 100%;
  color: ${(theme) => theme.colors.primary};
  position: absolute;
  top: 0;
  right: 0;
  min-width: 2.5rem;
  background: white;
`;
function Input(_a) {
    var { withoutSearchIcon, defaultValue, setValue } = _a, props = __rest(_a, ["withoutSearchIcon", "defaultValue", "setValue"]);
    (0, react_1.useEffect)(() => {
        setValue('search', defaultValue !== null && defaultValue !== void 0 ? defaultValue : '');
    }, [defaultValue, setValue]);
    const suffix = withoutSearchIcon ? undefined : ((0, jsx_runtime_1.jsx)(StyledSubmit, Object.assign({ kind: ['icon', 'transparent'] }, { children: (0, jsx_runtime_1.jsx)(svg_1.SvgSearch, {}) })));
    return ((0, jsx_runtime_1.jsx)(StyledTextInput, Object.assign({}, props, { name: "search", defaultValue: defaultValue, suffix: suffix, optional: true })));
}
function SearchForm({ children }) {
    const { push } = (0, app_1.useRouter)();
    const { pathname, params: { sort, category, sortOrder }, } = (0, hooks_1.useSearchMeta)();
    return ((0, jsx_runtime_1.jsx)(ui_1.Form, Object.assign({ contextOnly: true, onSubmit: (data) => {
            void push(new app_1.Href(pathname, Object.assign(Object.assign(Object.assign(Object.assign({}, (sort ? { sort } : {})), (sortOrder ? { sortOrder } : {})), (category ? { category } : {})), (data.search ? { search: data.search } : {}))), { shallow: true });
        } }, { children: children })));
}
function SearchInput(_a) {
    var { withoutSearchIcon } = _a, props = __rest(_a, ["withoutSearchIcon"]);
    const { query } = (0, app_1.useRouter)();
    return ((0, jsx_runtime_1.jsx)(SearchForm, { children: (0, jsx_runtime_1.jsx)(ui_1.FormContext, { children: ({ setValue }) => ((0, jsx_runtime_1.jsx)(Input, Object.assign({}, props, { name: "search", withoutSearchIcon: withoutSearchIcon, defaultValue: query === null || query === void 0 ? void 0 : query.search, setValue: setValue }))) }) }));
}
exports.SearchInput = SearchInput;
SearchInput.Form = SearchForm;
SearchInput.Input = Input;
